import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { useHighlightText } from '../../../hooks/useHighlightText';

export interface INavigationHeader {
  title: string,
  goForward: () => void;
  goBack: () => void;
  disabledGoBack: boolean;
  disabledGoForward: boolean;
}

const NavigationHeader = ({ title, goBack, goForward, disabledGoBack, disabledGoForward }: INavigationHeader) => {

  const { highlight } = useHighlightText();

  return (
    <div className="flex justify-between gap-4 py-4 px-4 md:px-8 rounded-t-md bg-brand-green-30">
      <button
        disabled={disabledGoBack}
        onClick={goBack}
        className={`flex items-center text-primary-100 transition-all duration-200 enabled:hover:brightness-110 ${disabledGoBack ? 'opacity-60 cursor-not-allowed' : ''}`}
      >
        <FiChevronLeft size={18} />
        <span className='text-lmedium hidden md:inline'>Gráfico anterior</span>
      </button>
      <h6 className="text-primary-100 text-tsmall md:text-tmedium text-center w-[65%]">
        {highlight(title)}
      </h6>
      <button
        disabled={disabledGoForward}
        onClick={goForward}
        className={`flex items-center text-primary-100 transition-all duration-200 enabled:hover:brightness-110 ${disabledGoForward ? 'opacity-60 cursor-not-allowed' : ''}`}
      >
        <span className='text-lmedium hidden md:inline'>Siguiente gráfico</span>
        <FiChevronRight size={18} />
      </button>
    </div>
  )
}

export default NavigationHeader